export default "<main class=\"payment-container\">\n    <app-payment-choose-plan></app-payment-choose-plan>\n</main>\n"